import i18next from 'i18next';
import { useState } from 'react';
import * as bd from 'react-basic-design';

import { languages } from '../../../app/constatnts.js';
import settings from '../../../app/settings.ts';
import SvgDevices from '../../../assets/icons/Devices';
import SvgLanguage from '../../../assets/icons/Language';
import SvgLock from '../../../assets/icons/Lock';
import SvgMail from '../../../assets/icons/Mail';
import SvgPhoneIphone from '../../../assets/icons/PhoneIphone';
import { T } from '../../../components/basic/text';

export const UserProfileInfo = ({ model, setModel }) => {
    const defaultLanguageCode = 'fa';
    const [darkMode, setDarkMode] = useState(bd.helper.isDarkMode());

    const [currentLanguageCode, setCurrentLanguageCode] = useState(
        settings.getLanguageCode() || defaultLanguageCode
    );

    const currentLanguage = languages.find(l => l.id === currentLanguageCode) ?? languages[0];

    const changeDarkMode = value => {
        bd.helper.setTheme(value ? 'bd-quartz-dark' : 'bd-quartz-light');
        setDarkMode(value);
    };

    const setLang = lang => {
        bd.helper.setRTL(lang === 'fa');
        i18next.changeLanguage(lang);
        setCurrentLanguageCode(lang);
    };

    const changeLanguageHandler = () => {
        bd.msgbox(<T className="text-secondary-text">select-language</T>, hide => {
            return languages.map(x => (
                <bd.Button
                    key={x.id}
                    className="w-100"
                    onClick={() => {
                        setLang(x.id);
                        hide();
                    }}
                >
                    {x.title}
                </bd.Button>
            ));
        });
    };

    return (
        <>
            <bd.Button
                variant="contained"
                className="d-block w-100 mb-3"
                onClick={() => setModel({ ...model, _id: 'edit-profile' })}
            >
                <T>edit-profile</T>
            </bd.Button>

            <div>
                <ul className="list-unstyled pt-0 px-0 d-flex flex-column gap-2">
                    <li className="d-flex align-items-center gap-2">
                        <SvgPhoneIphone className="size-md" />
                        {model.user.phoneNumber && <label>{model.user.phoneNumber}</label>}
                        {!model.user.phoneNumber && (
                            <T className="text-muted">phone-number-not-defined</T>
                        )}
                    </li>

                    <li className="d-flex align-items-center  gap-2">
                        <bd.Flex content="between" align="center">
                            <div className="d-flex align-items-center gap-2">
                                <SvgMail className="size-md" />
                                {model.user.email && <label>{model.user.email} </label>}
                                {!model.user.email && (
                                    <T className="text-muted">email-not-defined</T>
                                )}
                            </div>
                        </bd.Flex>
                    </li>

                    {model.user.defaultLanguage && (
                        <li className="d-flex flex-column align-items-start gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <SvgLanguage className="size-md" />
                                <T>default-language</T>
                                <label>
                                    (
                                    {languages.find(x => x.id == model.user.defaultLanguage)?.title}
                                    )
                                </label>
                            </div>
                            <T as="div" className="small text-muted ">
                                the-default-language-for-determining-the-language-of-receiving-messages-is-sms-and-email.
                            </T>
                        </li>
                    )}

                    <li>
                        <div className="border-bottom pt-3 mb-2"></div>
                    </li>

                    <li>
                        <div>
                            <SvgLock className="size-md" />

                            <bd.Button
                                onClick={() => setModel({ ...model, _id: 'change-password' })}
                            >
                                <T>change-password</T>
                            </bd.Button>
                        </div>

                        <div>
                            <SvgDevices className="size-md" />

                            <bd.Button onClick={() => setModel({ ...model, _id: 'view-devices' })}>
                                <T>view-devices</T>
                            </bd.Button>
                        </div>
                    </li>
                    <li>
                        <div className="border-bottom pt-3 mb-2"></div>
                    </li>

                    <li>
                        <bd.Flex align="center" className="mb-2">
                            <label className="m-e-auto">
                                <T>dark-mode</T>
                            </label>
                            <bd.Switch model={darkMode} setModel={changeDarkMode} size="sm" />
                        </bd.Flex>
                    </li>

                    <li>
                        <bd.Flex align="center">
                            <label className="m-e-auto">
                                <T>language</T>
                            </label>
                            <bd.Button
                                variant="outline"
                                disableRipple
                                size="sm"
                                onClick={changeLanguageHandler}
                            >
                                {currentLanguage.title}
                            </bd.Button>
                        </bd.Flex>
                    </li>
                </ul>
            </div>
        </>
    );
};
